<template>
  <main v-if="$store.getters.USERPROFILE['campaign-administration']">
    <section
      class="whiteBox"
      v-if="!descCoupon && !productAssociate && !productAssociateWithMultipleGroupOfDiscounts"
    >
      <div class="content">
        <h1 v-if="!this.$route.params.id">{{$t('createCampaign.title')}}</h1>
        <h1 v-else>{{$t('campaigns.modifyCampaignAction')}}</h1>
      </div>
      <div class="row">
        <div
          class="row"
          v-if="!this.$route.params.id"
        >
          <div
            class="formBox accentuate pointer"
            :class="{ 'blueSelect': campaign['campaign-type-global'] }"
            @click="campaign['campaign-type-global'] = true"
          >{{$t('createCampaign.uniqueCoupon')}}</div>
          <div
            class="formBox accentuate pointer"
            :class="{ 'blueSelect': !campaign['campaign-type-global'] }"
            @click="campaign['campaign-type-global'] = false"
          >{{$t('createCampaign.multipleCoupons')}}</div>
        </div>
        <div
          class="row"
          v-else
        >
          <div
            class="formBox accentuate pointer"
            :class="{ 'blueSelect': true }"
          >{{ this.campaign['campaign-type-global'] ? $t('createCampaign.uniqueCoupon') : $t('createCampaign.multipleCoupons')}}</div>
        </div>
      </div>
      <div
        class="row whiteBg"
        v-if="campaign['campaign-type-global']"
      >
        <i class="far fa-dot-circle blueColor"></i>
        <p class="tips">{{$t('createCampaign.generalDescription')}}</p>
        <div class="separator"></div>
        <i class="far fa-dot-circle"></i>
        <p class="tips">{{$t('createCampaign.couponDescription')}}</p>
        <div class="separator"></div>
        <i class="far fa-dot-circle"></i>
        <p class="tips">{{$t('createCampaign.associateProduct')}}</p>
      </div>
      <div
        class="row whiteBg"
        v-else
      >
        <i class="far fa-dot-circle blueColor"></i>
        <p class="tips">{{$t('createCampaign.generalDescription')}}</p>
        <div class="separator"></div>
        <i class="far fa-dot-circle"></i>
        <p class="tips">{{$t('createCampaign.associateProduct')}}</p>
      </div>
      <!-- Campaign Name, Date and Description -->
      <div class="content">
        <label>{{$t('createCampaign.name')}}</label>
        <span
          class="errorSentence"
          v-if="nameIsEmpty && isSubmitted"
        >* {{$t('error.textFieldRequired')}}</span>
        <div class="row alignCenter">
          <div class="demiRow">
            <input
              type="text"
              v-model="campaign.name"
              v-bind:class="{ 'error' : nameIsEmpty && isSubmitted }"
            >
          </div>
          <div class="demiRow">
            <p class="tips">{{$t('createCampaign.usedToFindYourCoupon')}}</p>
          </div>
        </div>
        <div class="row">
          <label class="container">
            <input
              type="checkbox"
              v-model="isCampaignRestricted"
            />
            <span class="checkmark"></span>{{$t('createCampaign.restrictedUse')}}
          </label>
          <p class="tips">{{$t('createCampaign.restrictedUseTips')}}</p>
        </div>
        <div class="spacer-10"></div>
                <div class="row" v-if="!campaign['campaign-type-global']">
          <label class="container">
            <input
              type="checkbox"
              v-model="isCampaignCouponAttribution"
            />
            <span class="checkmark"></span>{{$t('createCampaign.supportCampaign')}}
          </label>
          <p class="tips">{{$t('createCampaign.supportCampaignTips')}}</p>
        </div>
        <div class="spacer-10"></div>
        <div class="row">
          <label>{{$t('createCampaign.beginDate')}}</label>
          <p class="chip grey">{{$t('createCampaign.optional')}}</p>
        </div>
        <div class="row alignCenter">
          <div class="demiRow">
            <input
              type="date"
              class="sInput textCenter"
              v-model="campaign.tempDate['start-date']"
            >
            <input
              type="time"
              class="xsInput textCenter"
              v-model="campaign.tempDate.startHour"
            >
          </div>
          <div class="demiRow">
            <p class="tips">{{$t('createCampaign.leaveEmptyForImmediateUse')}}</p>
          </div>
        </div>
        <div class="row">
          <label>{{$t('createCampaign.endDate')}}</label>
          <p class="chip grey">{{$t('createCampaign.optional')}}</p>
        </div>
        <div class="row alignCenter">
          <div class="demiRow">
            <input
              type="date"
              class="sInput textCenter"
              v-model="campaign.tempDate['expiration-date']"
            >
            <input
              type="time"
              class="xsInput textCenter"
              v-model="campaign.tempDate.endHour"
            >
          </div>
          <div class="demiRow">
            <p class="tips">{{$t('createCampaign.leaveEmptyForNoTimeLimit')}}</p>
          </div>
        </div>
        <div class="row">
          <label>{{$t('createCampaign.description')}}</label>
          <p class="chip grey">{{$t('createCampaign.optional')}}</p>
        </div>
        <div class="row alignCenter">
          <div class="demiRow">
            <textarea
              rows="2"
              v-model="campaign.description"
            ></textarea>
          </div>
          <div class="demiRow">
            <p class="tips">
              {{$t('createCampaign.descLabel')}}
              <br>
              {{$t('createCampaign.invisibleToClient')}}
            </p>
          </div>
        </div>
      </div>
      <hr>
      <div class="content">
        <div class="row">
          <label class="container">
            <input
              type="checkbox"
              v-model="isPersonnalized"
            />
            <span class="checkmark"></span>{{$t('createCampaign.personalize')}}
          </label>
          <p class="tips">{{$t('createCampaign.selectToPersonalize')}}</p>
        </div>
        <!-- Personalize Bloc -->
        <Personnalize
          v-if="isPersonnalized"
          :couponPreview="couponPreview"
        ></Personnalize>
      </div>
      <hr>
      <div class="content">
        <div class="row">
          <button @click="finalizeCampaign">{{$t('button.next')}}</button>
          <a @click="goBack()">{{$t('button.cancel')}}</a>
        </div>
      </div>
    </section>
    <!-- unique coupon campaign-->
    <ManageCoupon
      v-if="descCoupon"
      :parCampaign="campaign"
      :parGroupOfDiscounts="groupOfDiscounts"
      @updatecampaign="updateCampaignFromChild"
      @next="goToStep('productAssociate')"
      @return="descCoupon = false"
    ></ManageCoupon>
    <ManageDiscounts
      v-if="productAssociate"
      :parCampaign="campaign"
      :parGroupOfDiscounts="groupOfDiscounts"
      @updatediscounts="updateDiscountsListFromChild"
      @return="goToStep('descCoupon')"
    ></ManageDiscounts>

    <!-- several coupons campaign-->
    <ManageDiscountsAndGroupsOfDiscounts
      v-if="productAssociateWithMultipleGroupOfDiscounts && !campaign['campaign-type-global']"
      :couponIsUnique="campaign['campaign-type-global']"
      :parCampaign="campaign"
      :parGroupsOfDiscounts="listOfGroupsOfDiscounts"
      :parDynamicIndex="index"
      @groupsofdiscountupdated="updateGroupsOfDiscounts"
      @return="goToStep('create')"
    ></ManageDiscountsAndGroupsOfDiscounts>
  </main>
  <main v-else>
    <NoAccess></NoAccess>
  </main>
</template>

<script>
import ManageCoupon from "@/components/campaigns/manageCampaign/uniqueCampaign/ManageCoupon";
import Personnalize from "@/components/campaigns/manageCampaign/Personnalize";
import ManageDiscounts from "@/components/campaigns/manageCampaign/uniqueCampaign/ManageDiscounts";
import ManageDiscountsAndGroupsOfDiscounts from "@/components/campaigns/manageCampaign/groupCampaign/ManageDiscountsAndGroupsOfDiscounts";
import NoAccess from "@/components/layout/NoAccess";
import Navigation from "@/mixins/navigation";
import generalMethods from "@/mixins/generalMethods";
import Campaigns from "@/services/Campaigns";
export default {
  mixins: [Navigation, generalMethods],
  components: {
    ManageCoupon,
    ManageDiscounts,
    NoAccess,
    Personnalize,
    ManageDiscountsAndGroupsOfDiscounts
  },
  data() {
    return {
      index: "",
      listOfGroupsOfDiscounts: [],
      isSubmitted: false,
      isCampaignRestricted: false,
      isCampaignCouponAttribution:false,
      campaign: {
        id: "",
        "campaign-type-global": true,
        "restricted-use": 0,
        name: "",
        tempDate: {
          "start-date": "",
          startHour: "",
          "expiration-date": "",
          endHour: ""
        },
        "start-date": "",
        "expiration-date": "",
        description: "",
        "global-code": "",
        "max-number-of-uses": "",
        "max-number-of-uses-per-client": ""
      },
      couponPreview: {
        imgUrl: "",
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000"
        }
      },
      groupsOfDiscounts: [], //gestion campagne de plusieurs coupons
      groupOfDiscounts: null, //gestion campagne de coupon unique
      isPersonnalized: false,
      descCoupon: false,
      productAssociate: false,
      productAssociateWithMultipleGroupOfDiscounts: false
    };
  },
  computed: {
    nameIsEmpty: function() {
      if (!this.campaign.name) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    $route(to, from) {
      if (from.name == "updateCampaign" && to.name == "createCampaign") {
        this.emptyCampaignData();
        this.getCampaign();
      }
    }
  },
  mounted() {
    this.getCampaign();
  },
  methods: {
    emptyCampaignData() {
      this.index = "";
      (this.listOfGroupsOfDiscounts = []),
        (this.isSubmitted = false),
        (this.isCampaignRestricted = false),
        (this.campaign = {
          id: "",
          "campaign-type-global": true,
          "restricted-use": 0,
          name: "",
          tempDate: {
            "start-date": "",
            startHour: "",
            "expiration-date": "",
            endHour: ""
          },
          "start-date": "",
          "expiration-date": "",
          description: "",
          "global-code": "",
          "max-number-of-uses": "",
          "max-number-of-uses-per-client": ""
        }),
        (this.couponPreview = {
          imgUrl: "",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000"
          }
        }),
        (this.groupsOfDiscounts = []),
        (this.groupOfDiscounts = null),
        (this.isPersonnalized = false),
        (this.descCoupon = false),
        (this.productAssociate = false),
        (this.productAssociateWithMultipleGroupOfDiscounts = false);
    },
    getCampaign() {
      if (this.$route.params.id) this.getNewData(this.$route.params.id, "get");
    },
    goBack() {
      if (this.campaign.id && this.campaign.status != 0) {
        if (this.campaign["campaign-type-global"]) {
          this.$router.push({
            name: "detailUniqueCampaign",
            params: { id: this.campaign.id }
          });
        } else {
          this.$router.push({
            name: "detailGroupCampaign",
            params: { id: this.campaign.id }
          });
        }
      } else {
        this.$router.push({
          name: "allCampaigns",
          params: { campaignType: "active" }
        });
      }
    },
    //unique coupon campaign update
    updateCampaignFromChild(data) {
      if (data) this.groupOfDiscounts = data;
    },
    updateDiscountsListFromChild(data) {
      if (data) this.groupOfDiscounts.discountsList = data;
    },
    updateGroupsOfDiscounts(data) {
      this.index = data.index;
      this.listOfGroupsOfDiscounts = data.list;
    },
    goToStep(part) {
      if (part == "create") {
        this.productAssociate = false;
        this.descCoupon = false;
        this.productAssociateWithMultipleGroupOfDiscounts = false;
      } else if (part == "productAssociate") {
        this.productAssociate = true;
        this.descCoupon = false;
        this.productAssociateWithMultipleGroupOfDiscounts = false;
      } else if (part == "descCoupon") {
        this.productAssociate = false;
        this.descCoupon = true;
        this.productAssociateWithMultipleGroupOfDiscounts = false;
      } else if (part == "productAssociateWithMultipleGroupOfDiscounts") {
        this.productAssociate = false;
        this.descCoupon = false;
        this.productAssociateWithMultipleGroupOfDiscounts = true;
      }
    },
    finalizeCampaign() {
      this.isSubmitted = true;
      // Campaign name is ok
      if (!this.nameIsEmpty) {
        if (this.isPersonnalized) {
          this.campaign[
            "background-color"
          ] = this.couponPreview.style.backgroundColor;
          this.campaign["image-URL"] = this.couponPreview.imgUrl;
          this.campaign["text-color"] = this.couponPreview.style.color;
        }
        this.campaign["start-date"] = this.convertDateAndHourToIsoFrLocale(
          this.campaign.tempDate["start-date"],
          this.campaign.tempDate["startHour"],
          "start"
        );
        this.campaign["expiration-date"] = this.convertDateAndHourToIsoFrLocale(
          this.campaign.tempDate["expiration-date"],
          this.campaign.tempDate["endHour"],
          "end"
        );
        if (this.isCampaignRestricted) this.campaign["restricted-use"] = 1;
        else this.campaign["restricted-use"] = 0;

        this.campaign["coupon-attribution"] = this.isCampaignCouponAttribution ? true : false;
        // if add
        if (!this.$route.params.id&&!this.campaign.id) {
          Campaigns.add(this.campaign).then(res => {
            let location = res.headers.location.split("/");
            this.campaign.id = location[location.length - 1];
            this.getNewData(this.campaign.id, "next");
          });
          //if modify
        } else {
          Campaigns.partialUpdate(this.campaign.id, this.campaign).then(() => {
            this.getNewData(this.campaign.id, "next");
          });
        }
      }
    },

    getNewData(id, context) {
      Campaigns.getById(id).then(data => {
        if (data.status == 200) {
          this.campaign = data.data;
          this.couponPreview.style.backgroundColor =
            data.data["background-color"];
          this.couponPreview.imgUrl = data.data["image-URL"];
          this.couponPreview.style.color = data.data["text-color"];
          if (
            this.couponPreview.imgUrl != "" ||
            this.couponPreview.style.color != "#000000" ||
            this.couponPreview.style.backgroundColor != "#FFFFFF"
          ) {
            this.isPersonnalized = true;
          }

          this.campaign.tempDate = {};
          var dateAndHourStartDate = this.convertIsoFrLocaleToDateAndHour(
            data.data["start-date"]
          );
          this.campaign.tempDate["start-date"] = dateAndHourStartDate.date;
          this.campaign.tempDate.startHour = dateAndHourStartDate.hour;
          var dateAndHourExpirationDate = this.convertIsoFrLocaleToDateAndHour(
            data.data["expiration-date"]
          );
          this.campaign.tempDate["expiration-date"] =
            dateAndHourExpirationDate.date;
          this.campaign.tempDate.endHour = dateAndHourExpirationDate.hour;

          if (this.campaign["restricted-use"] == 0)
            this.isCampaignRestricted = false;
          else this.isCampaignRestricted = true;
          this.isCampaignCouponAttribution = this.campaign["coupon-attribution"];
          if (context == "next") {
            if (this.campaign["campaign-type-global"]) {
              this.goToStep("descCoupon");
            } else {
              this.goToStep("productAssociateWithMultipleGroupOfDiscounts");
            }
          }
        }
      });
    }
  }
};
</script>

